import { useGlobalState } from '..';

export const useGameState = () => useGlobalState('game');
